import { DialogWithForm } from '@strata/react-dialog';
import { TextInputFormik } from '@strata/react-inputs';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { BulkChangeWarningMessage } from 'components/upcomingTreatments/dialogs/BulkChangeWarningMessage';
import { useAddToBatchMutation } from 'store/api/goLiveApi';

const Title = 'Create batch';

export const CreateBatchDialog = ({
    isOpen,
    onClose,
    treatmentsCount = 0,
    apiQueryParams = undefined,
}) => {
    const [addToBatch] = useAddToBatchMutation();

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validationSchema={Yup.object({
                batchName: Yup.string()
                    .required(validationStrings.requiredField.errorMessage)
                    .max(50, validationStrings.maxCharacter[50]),
            })}
            onSubmit={async ({ batchName }, { resetForm }) => {
                await addToBatch({
                    batch: { name: batchName },
                    ...apiQueryParams,
                }).unwrap();
                SuccessToast({ message: 'Upcoming treatments batch successfully created.' });
                resetForm();
                onClose();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    isOpen={isOpen}
                    width={440}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        formik.resetForm();
                        onClose();
                    }}
                    primaryButtonLabel={Title}
                    isPrimaryButtonDisabled={
                        !(formik.dirty && formik.isValid) || formik.isSubmitting
                    }
                    dialogContent={
                        <>
                            <TextInputFormik id="batchName" label="Batch Name" required />
                            <BulkChangeWarningMessage
                                apiQueryParams={apiQueryParams}
                                treatmentsCount={treatmentsCount}
                            />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

CreateBatchDialog.Title = Title;

CreateBatchDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentsCount: PropTypes.number,
    apiQueryParams: PropTypes.shape({
        treatmentId: PropTypes.string,
        searchText: PropTypes.string,
        goLiveDate: PropTypes.arrayOf(PropTypes.string),
        productServiceOid: PropTypes.arrayOf(PropTypes.string),
        segmentId: PropTypes.arrayOf(PropTypes.string),
        incumbentSupplier: PropTypes.arrayOf(PropTypes.string),
        productType: PropTypes.arrayOf(PropTypes.string),
        isLDD: PropTypes.arrayOf(PropTypes.bool),
        hasIssues: PropTypes.arrayOf(PropTypes.string),
        releaseStatus: PropTypes.arrayOf(PropTypes.string),
        upcomingTreatmentBatchName: PropTypes.arrayOf(PropTypes.string),
        preferredPharmacyOffer: PropTypes.arrayOf(PropTypes.string),
        therapeuticCategory: PropTypes.arrayOf(PropTypes.string),
    }),
};
